import { useState } from 'react';

import endpoints from '../../../../../../../../../api/endpoints';
import { BusinessError } from '../../../../../../../../common/business-error';
import { handleResponseError } from '../../../../../../../../../api/handleResponseError';
import { addParams, fetchWithTokenRefresh } from '../../../../../../../../../api/fetchWithTokenRefresh';

import { getEditAccountBusinessError } from '../businessErrors';
import { UPDATE_ACCOUNT_DIALOG_STEPS, AccountInfo } from '../interfaces';

type DialogError = BusinessError | null;

export const useEditAccount = () => {
  const [editAccountLoading, setLoading] = useState<boolean>(false);
  const [editAccountError, setError] = useState<DialogError>(null);

  const handleEditAccount = async (
    accountData: AccountInfo,
    onSuccess: (newStep: UPDATE_ACCOUNT_DIALOG_STEPS, ussdShortcode?: string, userMsisdn?: string) => void
  ) => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetchWithTokenRefresh(endpoints.clientSettingsUpdateOrder, addParams('POST', accountData));

      if (response.status !== 200) {
        await handleResponseError(response);
      }

      const jsonResponse = await response.json();

      if (jsonResponse.otp) {
        const otpShortcode = jsonResponse.otp.ussdShortcodeToDial;
        const userMsisdn = jsonResponse.otp.msisdn;
        onSuccess(UPDATE_ACCOUNT_DIALOG_STEPS.OTP_VERIFICATION_SMS_OR_SMS_AND_USSD, otpShortcode, userMsisdn);
      } else {
        onSuccess(UPDATE_ACCOUNT_DIALOG_STEPS.EDIT_FORM);
      }

      setLoading(false);
    } catch (e) {
      const { message, severity } = getEditAccountBusinessError(e);

      setError({ message, severity });
      setLoading(false);
    }
  };

  return { editAccountError, editAccountLoading, handleEditAccount };
};
